/**
 * @file 工具方法
 * @description 提供公用的工具 tools
 */

/**
 * 获取URL指定key的参数值
 * @param {string} key
 * @returns {string}
 */
export function getQueryString(key) {
  let reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)');
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return '';
}

/**
 * 修改url地址参数
 * @param {*} str 
 */
export function updateQueryStringParameter(uri, key, value) {
	if(!value) {
		return uri;
	}
	var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
	var separator = uri.indexOf('?') !== -1 ? "&" : "?";
	if (uri.match(re)) {
		return uri.replace(re, '$1' + key + "=" + value + '$2');
	}
	else {
		return uri + separator + key + "=" + value;
	}
}

/**
 * 修改当前地址参数
 * @param {string} key
 * @param {string} value
 */
export function updateUrlParam(key, value) {
  window.history.replaceState(null, '', updateQueryStringParameter(window.location.href, `${key}`, `${value}`))
}

/**
 * '-'的css属性名转驼峰
 * @param {string} key
 * @returns {string}
 */
export function cssStyle2DomStyle(str){
  var re=/-(\w)/g;
  return str.replace(re,function ($0,$1){
    return $1.toUpperCase();
  });
}

/**
 * css样式的对象转为驼峰对象
 * @param {string} key
 * @returns {string}
 */
export function cssObj2DomObj(cssObj) {
  let domObj = {};
  for(let attr in cssObj) {
    domObj[cssStyle2DomStyle(attr)] = cssObj[attr];
  }
  return domObj;
}

/**
 * 转换成
 * @param {object} data 组件原有的基于320设计稿的style数据，含有px的数据需要转换成rem
 * @returns {object} 处理后的style数据
 */
export function convertStyleData(data) {
  let obj = {};
  for(let attr in data) {
    let value = data[attr];
    if (value === value + '') {
      value = value.replace(/;/gi, ''); // 去掉可能会存在分号的数据
      if (value.indexOf('px') > -1) {
        if (!isNaN(Number(value.replace(/px/gi, '')))) {
          value = transformPx2Rem(value, 320);
        }
      }
    }
    obj[cssStyle2DomStyle(attr)] = value;
  }
  return obj;
}

/**
 * 将行内样式转换成obj格式,并且转换单位
 * @param {string} data - 比如 'font-size: 100rpx, margin: 100px;
 * @returns {object} 处理后的style数据 - {fontSzie: 1rem, margin: 2rem}
 */
export function convertLineStyleData(data = '') {
  let obj = {};
  getOld2NewCssData(data)
    .split(';')
    .forEach((item) => {
      if (item) {
        const splitStyle = item.split(/:/);
        if (splitStyle.length > 2) {
          splitStyle[1] = splitStyle.slice(1).join(':');
        }
        const key        = cssStyle2DomStyle(splitStyle[0].trim());
        const value      = splitStyle[1].trim();
        obj[key]         = value;
      }
    })
  return obj;
}

// rpx -> rem, px -> rem
export function getOld2NewCssData(data) {
  const rpx2remData = zoomUnit(data, 0.01, 'rpx', 'rem');
  return zoomUnit(rpx2remData, 0.02, 'px', 'rem');
}

/**
 * css单位倍数转换
 * @text：css字符串
 * @time:转后倍数（0.1 10）
 * @unit:单位
 * @toUnit:转为什么单位(非必传,不传为原单位)*/
export function zoomUnit(text, times, unit, toUnit) {
  //匹配所有这个单位
  var unitRe = new RegExp('\\s*(\\d+)*(\\.)*(\\d+)*(-)*(\\d+)' + unit, 'img');
  //转化后单位
  var tranUnit = toUnit || unit;
  //匹配
  return text.replace(unitRe, function (x) {
      var result = x.trim().replace(unit, '');
      result = parseInt((+result) * 10000, 10) * times / 10000;
      return ' ' + result + tranUnit;
  });
}

/**
 * 标签行内样式转换
 * @desc 将style={}和style=""转换成正确单位的行内样式
 * @returns {string}
 */
export function convertTagStyle(data) {
  // 匹配带花括号
  const braceRe = /style={([\s\S]*?)}/gm;
  // 匹配带有字符串
  const strRe = /style="([\s\S]*?)"/gm;
  // 替换的后的值
  const braceRst = 'style={convertLineStyleData($1)}';
  const strRst = "style={convertLineStyleData('$1')}";
  return data.replace(braceRe, braceRst).replace(strRe, strRst);
}

/**
 * 标签替换
 * @desc 替换规则如下，如有补充再添加
 * 'Block' : 'React.Fragment',
 * 'View'  : 'div',
 * 'Text'  : 'text',
 * 'Form'  : 'form',
 * 'Video' : 'video',
 * 'Label' : 'label',
 * 'Button': 'button',
 * 'Input' : 'input',
 * 'Image' : 'img'
 */
export function convertHtmlTag(data) {
  const TAG_NAME = {
    'Block' : 'React.Fragment',
    'View'  : 'div',
    'Text'  : 'span',
    'Form'  : 'form',
    'Video' : 'video',
    'Label' : 'label',
    'Button': 'button',
    'Input' : 'input',
    'Image' : 'img'
  };
  const headReg = /(<Block)|(<View)|(<Text)|(<Form)|(<Video)|(<Label)|(<Button)|(<Input)|(<Image)/g;
  const tailReg = /(<\/Block>)|(<\/View>)|(<\/Text>)|(<\/Form>)|(<\/Video>)|(<\/Label>)|(<\/Button>)|(<\/Input>)|(<\/Image>)/g;
  // 替换首标签
  const head = data.replace(headReg, (x) => {
    return '<' + TAG_NAME[x.replace(/</, '')];
  });
  // 替换尾标签
  return head.replace(tailReg, (x) => {
    // 没有尾标签的可以直接删除
    if (x === '</Input>' || x === '</Image>') {
      return x.replace(x, '');
    } else {
      return '</' + TAG_NAME[x.replace(/<\/|>/g, '')] + '>';
    }
  });
}

/**
 * 检测是否符合手机规格
 * @param {string} key
 * @returns {string}
 */
export function checkIfPhone(phone){
  var regmTel = /^1\d{10}$/;
  if (regmTel.test(phone.trim())) {
    return true;
  } else {
    return false;
  }
}

/**
 * 转换对象为URL参数形式的方法
 * @param {obj} obj
 * @returns {string}
 */
export function tranform2UrlEncode(obj) {
  var query = '',
      name,
      value,
      fullSubName,
      subName,
      subValue,
      innerObj,
      i;
  for (name in obj) {
    value = obj[name];
    if (value instanceof Array) {
      for (i = 0; i < value.length; ++i) {
        subValue = value[i];
        fullSubName = name + '[' + i + ']';
        innerObj = {};
        innerObj[fullSubName] = subValue;
        query += tranform2UrlEncode(innerObj) + '&';
      }
    } else if (value instanceof Object) {
      for (subName in value) {
        subValue = value[subName];
        fullSubName = name + '[' + subName + ']';
        innerObj = {};
        innerObj[fullSubName] = subValue;
        query += tranform2UrlEncode(innerObj) + '&';
      }
    } else if (value !== undefined && value !== null)
      query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
  }
  return query.length ? query.substr(0, query.length - 1) : query;
}

/**
 * 获取cookie参数
 * @param {string} name
 * @returns {string | null}
 */
export function getCookiePara(name) {
  var name = name || 'PHPSESSID',
      reg = new RegExp("(^|\\D)" + name + "=([^&]*?)($|;)"),
      r = document.cookie.match(reg);

  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}

/**
 * 转换成
 * @param {string | number} origin 750px | 750
 * @param {number} redix 基数，原始值是基于750px设计稿的，要填750，默认750
 * @returns {string} 换算后再加上rem单位
 */
/*
 * 换算规则整理：
 * 1rem(wx) = 16px = 32rpx = .32rem(webapp)
 * 100vw = 7.5rem      当前设备宽度
 * 1rem  = 100/7.5vw   当前视图宽度的1/7.5
 * 1rpx  = 0.01rem (微信小程序转换提醒)
 * 750px设计稿: 1px换算成1/100rem（0.01rem）
 * 320px设计稿: 1px换算成7.5/320rem (100vw/320 = 7.5rem/320)
 * (备注：html font-size: 1rem > 12px，浏览器默认最小为12px）
 * (原理：满足750px设计稿的100vw = 750 px，1rem = 100x vw / 750份 > 12px => x > 90 && x为10的倍数 => x 取 100)
 * (同比小程序中750rpx等于这边的7.5rem，相互换算只需要/100或*100）
 */
export function transformPx2Rem(origin, redix = 750) {
  // 当前origin为数字
  if (origin === +origin) {
    return origin * 7.5 / redix + 'rem';
  } else if (origin === origin+'') { // 当前origin为字符串
    if (origin.indexOf('rem') > -1) {
      return origin;
    }
    return Number(origin.replace(/px/gi, '')) * 7.5 / redix + 'rem';
  } else {
    return '0rem';
  }
}

// TODO 后续应该换地方
export function getGoodsTypeByForm(form) {
  switch (form) {
    case 'goods':
      return 0;
    case 'appointment':
      return 1;
    case 'waimai':
      return 2;
    case 'tostore':
      return 3;
    case 'new_appointment':
      return 10;
    default:
      return 0;
  }
}

// TODO 后续应该换地方
export function getFormByGoodsType(gt) {
  var type = +gt || 0;
  switch (type) {
    case 0:
      return 'goods';
    case 1:
      return 'appointment';
    case 2:
      return 'waimai';
    case 3:
      return 'tostore';
    case 10:
      return 'new_appointment';
    default:
      return 'goods';
  }
}

/**
 * 根据URL获取参数数据对象
 * @param {string} url
 * @returns {string}
 */
export function getUrlQueryStringObj(url) {
  var qs = url.split('?')[1]; // 获取url中"?"符后的字串
  var args = {}; // 保存参数数据的对象
  var items = qs ? qs.split("&") : []; // 取得每一个参数项,
  var item = null;
  for(var i = 0; i < items.length; i++) {
    item = items[i].split("=");
    var name = decodeURIComponent(item[0]),
      value = decodeURIComponent(item[1]);
    if(name) {
      args[name] = value;
    }
  }
  return args;
}

/**
 * 根据state获取search 类似: ?param1=value1&param2=value2
 */
export function getUrlSearch(state = {}) {
  let search = '';
  for (let key in state) {
    if (`${state[key]}` && state[key] != 'undefined' && state[key] !== undefined) {
      search += `${key}=${encodeURIComponent(state[key])}&`
    }
  }
  return search ? `?${search}` : '';
}

/**
 * 获取当前页面路径中的参数
 */
export function getCurrentPageQueryParams() {
  let params = {};
  let search = window.location.search;
  let queryIndex = search.indexOf('?');
  if (queryIndex !== -1) {
    let queryString = search.substring(1);
    queryString.split('&').forEach((pair) => {
      let temp = pair.split('=');
      params[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
    });
  }
  return params;
}

/**
 * 产生随机字符串
 */
export function randomWord(length = 10) {
  let str = "";
  let arr = [
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  for (let i = 0; i < length; i++) {
    let pos = Math.round(Math.random() * (arr.length - 1));
    str += arr[pos];
  }
  return str;
}

/**
 * cookie 读写处理
 */
export const docCookies = {
  getItem: function (sKey) {
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  },
  setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
    var sExpires = "";
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
          break;
        case String:
          sExpires = "; expires=" + vEnd;
          break;
        case Date:
          sExpires = "; expires=" + vEnd.toUTCString();
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
    return true;
  },
  removeItem: function (sKey, sPath, sDomain) {
    if (!sKey || !this.hasItem(sKey)) { return false; }
    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + ( sDomain ? "; domain=" + sDomain : "") + ( sPath ? "; path=" + sPath : "");
    return true;
  },
  hasItem: function (sKey) {
    return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
  },
  keys: /* optional method: you can safely remove it! */ function () {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nIdx = 0; nIdx < aKeys.length; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
    return aKeys;
  }
};



// WEBPACK FOOTER //
// ./src/utils/tools.jsx